<template>
  <div
    :class="$style.root"
  >
    <pages-publications-header-component
      :data="data"
      v-if="showHeader"
    />

    <shared-blocks-component
      :blocks="data?.blocks"
      :class="$style.blocks"
      :default-font-size="false"
    />

    <shared-page-filtered-on-biennial-id-component
      parentName="publications"
      :label="$t('labels.publication', {count: 2})"
    />

    <pages-publications-nav-component
      v-if="publicationCategories?.length > 1"
      :class="$style.nav"
      :data="publicationCategories"
    />

    <pages-publications-list-component />
  </div>
</template>

<script lang="ts" setup>

const localePath = useLocalePath()
const route = useRoute()
const router = useRouter()

const props = defineProps({
  data: {
    type: Object,
    required: true
  },
  publicationCategories: {
    type: Array,
    required: false
  },
  showHeader: {
    type: Boolean,
    default: true
  }
})
</script>

<style module>
.root {}

.blocks {
  composes: container from global;
  margin-bottom: calc(var(--unit--vertical) * 2);
}

.nav {
  margin-bottom: calc(var(--unit--vertical) * 2);
}
</style>
